<template>

  <el-row  style="margin-top: 5px;">
    <el-col :span="2" :offset="4" style="text-align: right;">
      <span>所属项目：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.project_name}}</span>
    </el-col>

    <el-col :span="2" style="text-align: right;">
      <span>提出人：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.request_person}}</span>
    </el-col>
    <el-col :span="2" style="text-align: right;">
      <span>提出日期：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.request_date}}</span>
    </el-col>

    <el-col :span="2" style="text-align: right;">
      <span>工单状态：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.status_name}}</span>
    </el-col>
  </el-row>

  <el-row  style="margin-top: 5px;">
    <el-col :span="2" :offset="4" style="text-align: right;">
      <span>责任人：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.charge_user_name}}</span>
    </el-col>

    <el-col :span="2" style="text-align: right;">
      <span>优先级：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.priority}}</span>
    </el-col>

    <el-col :span="2" style="text-align: right;">
      <span>实现难度：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.difficulty}}</span>
    </el-col>

    <el-col :span="2" style="text-align: right;">
      <span>预估人天：</span>
    </el-col>
    <el-col :span="2" style="text-align: left;">
      <span>{{mainData.estimate_man_day}}</span>
    </el-col>
  </el-row>

  <el-row style="margin-top: 5px;margin-bottom: 20px">
    <el-col :span="12" :offset="6" style="text-align: center;padding: 5px;background-color: #efefef">
      <el-button size="small" style="margin-right: 10px" @click="dialogs.showAssign = true" :disabled="assignButton">指派</el-button>
      <el-button size="small" style="margin-right: 10px" @click="dialogs.showEstimate = true" :disabled="estimateButton">工单评估</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitClaimIssue" :disabled="claimButton">工单领取</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitCreateTask" :disabled="createTaskButton">创建任务</el-button>
      <el-button size="small" style="margin-right: 10px" @click="dialogs.showEditStatus = true" :disabled="editStatusButton">编辑状态</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitUrgeReminder" :disabled="urgeReminderButton">催促提醒</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitInquireStatus" :disabled="inquireStatusButton">询问状态</el-button>
      <el-button size="small" style="margin-right: 10px" @click="submitDelete" :disabled="delButton">删除</el-button>
    </el-col>
  </el-row>

  <el-row style="overflow-y: auto;max-height: 750px;padding: 20px">
    <el-col :span="18" >
      <div style="padding: 0 5px 0 5px">
        <el-row style="line-height: 24px;height: 24px;border: 1px solid #e5e5e5;background-color: whitesmoke">
          <el-col :span="20" style="text-align: left;">
            <span style="color: #666666;margin-left: 5px;">{{mainData.title}}</span>
          </el-col>
          <el-col :span="4" style="text-align: right;">
            <span style="color: #666666;margin-right: 5px;">{{mainData.id}}</span>
          </el-col>
        </el-row>

        <div style="border: 1px solid #e5e5e5;">
          <KfCkEditor :model-value="mainData.content" readonly ></KfCkEditor>
        </div>
        <el-row style="font-size: smaller; line-height: 24px;height: 24px;border: 1px solid #e5e5e5;background-color: whitesmoke">
          <el-col :span="24" style="text-align: right;">
            <span style="color: #666666;margin-right: 10px;">楼主</span>
            <span style="color: #666666;margin-right: 10px;">{{mainData.create_user_name}}</span>
            <span style="color: #666666;margin-right: 10px;">{{mainData.create_time}}</span>
          </el-col>
        </el-row>

        <div v-for="(item, index) in replyList" :key="index">
          <div style="border: 1px solid #e5e5e5;">
            <KfCkEditor :model-value="item.content" readonly  ></KfCkEditor>
          </div>
          <el-row style="font-size: smaller; line-height: 24px;height: 24px;border: 1px solid #e5e5e5;background-color: whitesmoke">
            <el-col :span="24" style="text-align: right;">
              <span style="color: #666666;margin-right: 10px;">第{{index+1}}楼</span>
              <span style="color: #666666;margin-right: 10px;">{{item.create_user_name}}</span>
              <span style="color: #666666;margin-right: 10px;">{{item.create_time}}</span>
<!--              <span style="color: #6699CC;margin-left: 10px;">回复</span>-->
              <span v-if="item.create_user_id === mainData.current_user_id" style="color: #6699CC;margin-left: 10px;" @click="delReply(item)">删除</span>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 10px;">添加回复</div>
        <div style="margin-top: 3px;border: 1px solid #e5e5e5;">
          <KfCkEditor v-model="replyContent" ></KfCkEditor>
        </div>
        <div style="margin-top: 5px">
          <el-button size="small" @click="submitReply" >提交回复</el-button>
        </div>
      </div>
    </el-col>
    <el-col :span="6">
      <div style="min-height: 600px;border: 1px solid #e5e5e5;" >
        <div style="border: 1px solid #e5e5e5;background-color: whitesmoke;padding-left: 5px">
          最新动态
        </div>
        <div v-for="(item, index) in logList" :key="index">
          <el-row style="font-size: smaller; line-height: 24px;height: 24px;border: 1px solid #e5e5e5;">
            <el-col :span="24" style="text-align: left;padding-left: 5px">
              <span style="color: #666666;margin-right: 10px;">{{item.create_time}}</span>
              <span style="color: #666666;margin-right: 10px;">{{item.create_user_name}}</span>
              <span style="color: #666666;margin-right: 10px;">{{item.content}}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-col>
  </el-row>

  <!-- 指派 对话框 -->
  <el-dialog title="指派责任人" v-model="dialogs.showAssign" :close-on-click-modal="false" width="450px">
    <el-form v-model="assignData" label-width="110px">
      <el-form-item label="责任人" required>
        <el-select v-model="assignData.charge_user_id" placeholder="指派到" clearable multiple>
          <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submitAssign">确定</el-button>
        <el-button @click="dialogs.showAssign = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <!-- 评估 对话框 -->
  <el-dialog title="工单评估" v-model="dialogs.showEstimate" :close-on-click-modal="false" width="450px">
    <el-form v-model="estimateData" label-width="110px">
      <el-form-item label="优先级">
        <el-select v-model="estimateData.priority" placeholder="优先级" clearable>
          <el-option v-for="item in priorityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实现难度">
        <el-select v-model="estimateData.difficulty" placeholder="实现难度" clearable>
          <el-option v-for="item in difficultyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预估人天">
        <el-input-number v-model="estimateData.estimate_man_day" step="0.1" min="0.1" max="999" placeholder="预估人天" clearable></el-input-number>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submitEstimate">确定</el-button>
        <el-button @click="dialogs.showEstimate = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

  <!--  创建任务  对话框-->
  <el-dialog title="创建任务" v-model="dialogs.showCreateTask" :close-on-click-modal="false" width="900px">
    <el-form v-model="taskData" label-width="110px">
      <el-row>
        <el-col :span="22">
          <el-form-item label="任务归属阶段" required>
            <el-cascader v-model="taskData.parent_id" :options="stageList" :props="optionProps" style="width: 100%"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="任务名称" required>
            <el-input v-model="taskData.name" placeholder="任务名称" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="进度" required>
            <el-input-number v-model="taskData.progress_percent" :min="0" :max="100" style="width: 100%"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="计划开始日期" required>
            <el-date-picker v-model="taskData.plan_start_date" type="date" placeholder="计划开始日期" style="width: 100%" clearable></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="计划结束日期" required>
            <el-date-picker v-model="taskData.plan_end_date" type="date" placeholder="计划结束日期" style="width: 100%" clearable></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="计划人天" required>
            <el-input-number v-model="taskData.plan_man_day" :min="1" placeholder="计划人天" style="width: 100%" clearable></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="责任人" required>
            <el-select v-model="taskData.charge_user_id" placeholder="请选择">
              <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="justify-content: center;width: 100%;margin-top: 10px">
        <el-button type="primary"  @click="createTask">
          保存
        </el-button>
      </el-row>
    </el-form>
  </el-dialog>

  <!-- 编辑状态 对话框 -->
  <el-dialog title="编辑状态" v-model="dialogs.showEditStatus" :close-on-click-modal="false" width="450px">
    <el-form v-model="editStatusData" label-width="110px">
      <el-form-item label="工单状态" required>
        <el-select v-model="editStatusData.status" placeholder="工单状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实际人天" required v-if="editStatusData.status === 'deal_finish'">
        <el-input-number v-model="editStatusData.actual_man_day" :min="0.1" style="width: 100%" clearable></el-input-number>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" @click="submitEditStatus">确定</el-button>
        <el-button @click="dialogs.showEditStatus = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

</template>

<script>

import {ElMessage, ElMessageBox} from "element-plus";

export default {
  name: 'IssueDetail',
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    priorityList() {
      return this.$store.getters['core/getDictList']('prj_priority');
    },
    difficultyList() {
      return this.$store.getters['core/getDictList']('prj_difficulty');
    },
    statusList() {
      return this.$store.getters['core/getDictList']('issue_status');
    }
  },
  data() {
    return {
      mainData: {},
      replyList: [],
      logList: [],
      replyContent: '',
      queryReplyData: {
        main_data_id: this.parentData.id,
        main_data_type: 'issue',
      },
      assignData: {
        id: this.parentData.id,
        charge_user_id: '',
      },
      estimateData: {
        id: this.parentData.id,
        priority: '',
        difficulty: '',
        estimate_man_day: 0
      },
      taskData: {
        project_id: this.parentData.project_id,
        related_data_type: 'issue',
        related_data_id: this.parentData.id,
        progress_percent: 0,
      },
      optionProps: {
        value: 'id',
        label: 'name',
        checkStrictly: true,
        emitPath: false
      },
      editStatusData: {
        id: this.parentData.id,
        status: ''
      },
      dialogs: {
        showAssign: false,
        showEstimate: false,
        showCreateTask: false,
        showEditStatus: false
      },
      assignButton: true,
      estimateButton: true,
      claimButton: false,
      createTaskButton: true,
      editStatusButton: false,
      urgeReminderButton: true,
      inquireStatusButton: true,
      delButton: true,
      userList:[],
      stageList:[]
    }
  },
  created() {
    this.loadUsers();
    this.getDetail();
    this.getReplyList();
    this.getStageList();
  },

  methods: {
    //获取任务归属阶段数据源
    async getStageList() {
      this.stageList = await this.$http('prjTaskService.getStageTaskByEdit',{project_id:this.parentData.project_id});
    },
    //获取项目成员
    async loadUsers() {
      this.userList = await this.$http('prjProjectService.getMemberAll', {project_id:this.parentData.project_id});
    },
    //获取工单全部信息
    async getDetail() {
      this.mainData = await this.$http('prjIssueService.getDetail',{id:this.parentData.id});
      await this.getLogList();

      //默认值
      this.estimateData.priority = this.mainData.priority
      this.estimateData.difficulty = this.mainData.difficulty
      this.estimateData.estimate_man_day = this.mainData.estimate_man_day

      // 更改任务状态后，对按钮进行禁用
      if (this.mainData.status === 'wait_estimate' || this.mainData.status === 'on_estimate' || this.mainData.status === 'wait_deal'){
        if (this.mainData.is_admin || this.mainData.create_user_id === this.mainData.current_user_id){
          this.assignButton = false;
          this.estimateButton = false;
          this.createTaskButton = false;
          this.urgeReminderButton = false;
          this.inquireStatusButton = false;
          this.delButton = false;
        } else {
          if (!this.mainData.charge_user_id.includes(this.mainData.current_user_id)){
            this.editStatusButton = true
          }
        }
        if (this.mainData.charge_user_id){
          this.claimButton = true;
        }
      } else {
        this.assignButton = true;
        this.estimateButton = true;
        this.createTaskButton = true;
        this.urgeReminderButton = true;
        this.inquireStatusButton = true;
        this.delButton = true;
        this.claimButton = true;
      }

      if (!this.mainData.is_admin){
        if (!this.mainData.charge_user_id.includes(this.mainData.current_user_id)){
          this.editStatusButton = true
        }
      }
    },
    //获取回复列表
    async getReplyList() {
      this.replyList = await this.$http('prjReplyService.getReplyList', this.queryReplyData);
      await this.getLogList();
    },
    //获取日志列表
    async getLogList() {
      this.logList = await this.$http('prjLogService.getLogList', this.queryReplyData);
    },

    //删除回复
    async delReply(replayData) {
      ElMessageBox.confirm(
          '你是否要删除这条回复',
          '删除回复',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjReplyService.delReply',replayData);
        await this.getReplyList();
        ElMessage({
          type: 'success',
          message: '操作成功，已删除成功',
        })
      })
    },

    //提交回复
    async submitReply(){
      if(this.replyContent === ''){
        this.$message.error('回复内容为空')
        return;
      }
      let params = {
        main_data_id: this.parentData.id,
        main_data_type: 'issue',
        content: this.replyContent
      };
      await this.$http('prjReplyService.addReply', params);
      this.$message.success('提交成功')
      await this.getReplyList();
      this.replyContent = ''
    },

    //提交指派负责人
    async submitAssign(){
      if(this.assignData.charge_user_id === ''){
        this.$message.error('未选择责任人')
        return;
      }
      await this.$http('prjIssueService.assign', this.assignData);
      this.$message.success('提交成功')
      await this.getDetail();
      this.dialogs.showAssign = false
    },

    //提交评估
    async submitEstimate(){
      // if(this.estimateData.priority === ''){
      //   this.$message.error('未选择优先级')
      //   return;
      // }
      // if(this.estimateData.difficulty === ''){
      //   this.$message.error('未选择实现难度')
      //   return;
      // }
      // if(this.estimateData.estimate_man_day === 0){
      //   this.$message.error('未输入预估人天')
      //   return;
      // }
      await this.$http('prjIssueService.estimate', this.estimateData);

      this.$message.success('提交成功')
      await this.getDetail();
      this.dialogs.showEstimate = false
    },

    //提交修改状态
    async submitEditStatus(){
      if(this.editStatusData.status === ''){
        this.$message.error('未选择工单状态')
        return;
      }
      if (this.editStatusData.status === 'deal_finish' && !this.editStatusData.actual_man_day){
        this.$message.error('请填写实际人天')
        return;
      }
      await this.$http('prjIssueService.editStatus', this.editStatusData);
      this.$message.success('提交成功')
      await this.getDetail();
      this.dialogs.showEditStatus = false
    },

    //工单领取
    submitClaimIssue(){
      ElMessageBox.confirm(
          '你是否要领取这个工单任务？',
          '工单领取',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjIssueService.claimIssue', this.mainData);
        await this.getDetail();
        this.claimButton = true;
        this.editStatusButton = false
        ElMessage({
          type: 'success',
          message: '操作成功，已领取',
        })
      })
    },

    //创建任务
    async submitCreateTask() {
      this.dialogs.showCreateTask = true
    },

    //提交创建任务
    async createTask() {
      if (!this.taskData.parent_id) {
        this.$message.error("请选择任务归属阶段！")
        return
      }
      if (!this.taskData.name) {
        this.$message.error("请填写任务名称！")
        return
      }
      if (!this.taskData.plan_start_date) {
        this.$message.error("请选择计划开始日期！")
        return
      }
      if (!this.taskData.plan_end_date) {
        this.$message.error("请选择计划完成日期！")
        return
      }
      if (!this.taskData.plan_man_day) {
        this.$message.error("请填写计划人天！")
        return
      }
      if (!this.taskData.charge_user_id) {
        this.$message.error("请选择责任人！")
        return
      }
      await this.$http('prjTaskService.addTask', this.taskData);
      this.$message.success('创建成功')
      await this.getLogList();
      this.dialogs.showCreateTask = false

    },

    //催促提醒
    async submitUrgeReminder(){
      ElMessageBox.confirm(
          '你是否需要通过在系统中发送消息进行催促？',
          '催促提醒',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjIssueService.urgeReminder', this.mainData);
        this.urgeReminderButton = true
        ElMessage({
          type: 'success',
          message: '操作成功，已发送',
        })
      })
    },

    //询问状态
    submitInquireStatus() {
      ElMessageBox.confirm(
          '你是否需要通过在系统中发送消息进行状态询问？',
          '询问状态',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(async () => {
        await this.$http('prjIssueService.inquireStatus', this.mainData);
        this.inquireStatusButton = true
        ElMessage({
          type: 'success',
          message: '操作成功，已发送',
        })
      })
    },

    //删除工单
    async submitDelete() {
      this.$confirm('删除后无法恢复，是否确认？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http('prjIssueService.del', this.editStatusData);
        this.$message.success('删除成功，请关闭本窗口')
      });
    },
  },
}
</script>

<style scoped>
.cke_read_only .cke_toolbox {
  display: none !important;
}
</style>